import { render, staticRenderFns } from "./UsoInventario.vue?vue&type=template&id=1a1ace1b&scoped=true&"
import script from "./UsoInventario.vue?vue&type=script&lang=js&"
export * from "./UsoInventario.vue?vue&type=script&lang=js&"
import style0 from "./UsoInventario.vue?vue&type=style&index=0&id=1a1ace1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ace1b",
  null
  
)

export default component.exports